/* Defer non-gallery PDP imagery, then prepare review slides after initial render. */
(() => {
  const selector = 'img[data-hmx-deferred-src]';
  const reviewSelector = '.tp-reviews img[data-hmx-deferred-src]';

  const hydrate = (image) => {
    if (!(image instanceof HTMLImageElement) || !image.dataset.hmxDeferredSrc) return;
    if (image.dataset.hmxDeferredSizes) image.sizes = image.dataset.hmxDeferredSizes;
    if (image.dataset.hmxDeferredSrcset) image.srcset = image.dataset.hmxDeferredSrcset;
    image.src = image.dataset.hmxDeferredSrc;
    image.removeAttribute('data-hmx-deferred-src');
    image.removeAttribute('data-hmx-deferred-srcset');
    image.removeAttribute('data-hmx-deferred-sizes');
  };

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            hydrate(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '160px 0px' })
    : null;

  const observeNonReviewImages = (root = document) => {
    root.querySelectorAll(selector).forEach((image) => {
      if (image.closest('.tp-reviews')) return;
      if (observer) observer.observe(image);
      else hydrate(image);
    });
  };

  const hydrateReviewImages = (root = document) => {
    root.querySelectorAll(reviewSelector).forEach((image, index) => {
      if (index === 0) hydrate(image);
      else window.setTimeout(() => hydrate(image), index * 120);
    });
  };

  const queueReviewHydration = (root = document) => {
    const run = () => hydrateReviewImages(root);
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: 1200 });
    } else {
      window.setTimeout(run, 350);
    }
  };

  const initialize = () => {
    observeNonReviewImages();
    queueReviewHydration();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    observeNonReviewImages(event.target);
    queueReviewHydration(event.target);
  });

  document.addEventListener('shopify:section:select', (event) => {
    queueReviewHydration(event.target);
  });
})();

/* HOMIXA PDP SHARED OPTIMIZATIONS - SHRINE */
(function () {
  function updateShippingDate() {
    var shippingDate = new Date();
    shippingDate.setHours(12, 0, 0, 0);
    shippingDate.setDate(shippingDate.getDate() + 1);

    var formattedDate = shippingDate.toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric"
    });

    document.querySelectorAll("[data-us-ship-date]").forEach(function (element) {
      element.textContent = formattedDate;
    });
  }

  function initialize() {
    updateShippingDate();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener("variant:change", function () {
    window.requestAnimationFrame(updateShippingDate);
  });

  document.addEventListener("click", function (event) {
    var button = event.target instanceof Element ? event.target.closest("[data-hmx-quantity]") : null;
    if (!button) return;

    var quantity = Number(button.dataset.hmxQuantity);
    var section = button.closest(".shopify-section") || document;
    var form = section.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    var input = form ? form.querySelector('[name="quantity"]') : null;

    if (form && !input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = "quantity";
      form.appendChild(input);
    }

    if (input) {
      input.value = String(quantity);
      input.dispatchEvent(new Event("change", { bubbles: true }));
      input.dispatchEvent(new Event("input", { bubbles: true }));
    }

    var bundle = button.closest(".hmx-bundle");
    if (bundle) {
      bundle.querySelectorAll("[data-hmx-quantity]").forEach(function (tier) {
        tier.setAttribute("aria-pressed", String(tier === button));
      });
    }
  });
})();


/* Adapt bundle tiers to Shrine's native add-to-cart link. */
(() => {
  const updateLink = (bundle, quantity) => {
    const section = bundle.closest('.shopify-section') || document;
    const link = section.querySelector('[data-add-to-cart-link]');
    if (!link) return;
    const url = new URL(link.href, window.location.origin);
    url.searchParams.set('quantity', String(quantity));
    link.href = url.pathname + url.search;
  };

  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-hmx-quantity]') : null;
    if (!button) return;
    updateLink(button.closest('.hmx-bundle'), Number(button.dataset.hmxQuantity));
  });

  document.addEventListener('variant:change', () => {
    document.querySelectorAll('.hmx-bundle').forEach((bundle) => {
      const selected = bundle.querySelector('[data-hmx-quantity][aria-pressed="true"]');
      if (selected) updateLink(bundle, Number(selected.dataset.hmxQuantity));
    });
  });
})();
